module.exports = __webpack_public_path__ + "img/bg.fe943848.png";